export default __webpack_public_path__ + "static/usa_ohio_rolling_cash-7fe33c4ce3f0decd442605815fd3381e.png";